import React, { useEffect, useState } from 'react';
function Particles() {
  const [particles, setParticles] = useState<{
    id: number;
    size: number;
    left: number;
    top: number;
    delay: number;
    duration: number;
  }[]>([]);
  useEffect(() => {
    const newParticles = Array.from({
      length: 25
    }).map((_, i) => ({
      id: i,
      size: Math.random() * 4 + 1,
      left: Math.random() * 100,
      top: Math.random() * 100,
      delay: Math.random() * 5,
      duration: Math.random() * 10 + 10
    }));
    setParticles(newParticles);
  }, []);
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-110">
      {particles.map(p => <div key={p.id} className="absolute rounded-full bg-gold/40 animate-float" style={{
      width: `${p.size}px`,
      height: `${p.size}px`,
      left: `${p.left}%`,
      top: `${p.top}%`,
      animationDelay: `${p.delay}s`,
      animationDuration: `${p.duration}s`
    }} data-id="element-111" />)}
    </div>;
}
export function HeroSection() {
  const scrollToTools = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.getElementById('tools-section');
    if (element) {
      const offset = 50; // Height of sticky top bar
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative w-full min-h-[80vh] flex flex-col items-center justify-center py-14 px-4 bg-navy bg-grain overflow-hidden" data-id="element-112">
      {/* Radial Gradient Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#1a153a] via-navy to-navy opacity-80 z-0" data-id="element-113"></div>

      <Particles data-id="element-114" />

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-115">
        <p className="text-warm-gold text-sm md:text-base tracking-[0.2em] uppercase mb-8 font-medium" data-id="element-116">
          For the woman who's done everything right — and still feels invisible
        </p>

        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-cream leading-[1.15] mb-8" data-id="element-117">
          What If The Problem Isn't Your Faith —
          <br className="hidden md:block" data-id="element-118" />
          <span className="italic opacity-90" data-id="element-119">It's A Frequency?</span>
        </h1>

        <p className="text-lg md:text-xl text-cream/90 max-w-2xl mx-auto mb-12 leading-relaxed font-light" data-id="element-120">
          You've prayed. You've meditated. You've done the work. And yet... the
          door keeps closing.
        </p>

        <a href="#tools-section" onClick={scrollToTools} className="inline-flex items-center justify-center px-8 py-4 md:px-10 md:py-5 bg-cta-red text-white font-semibold text-lg md:text-xl rounded-full animate-heartbeat hover:bg-red-700 transition-colors duration-300" data-id="element-121">
          Show Me Why Nothing Has Been Working →
        </a>
      </div>
    </section>;
}